import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
const VRTBridgeInner = dynamic(() => import('./VRTBridgeInner'), {
  ssr: false
});

/**
 * VRT (Visual Regression Testing) bridge component.
 * Dynamically loads when `?__vrt` query param is present.
 * Exposes `window.__VRT__` for Playwright to open modals programmatically.
 * Minimal bundle impact — only this thin wrapper is included;
 * the inner bridge + modal code is dynamically imported when activated.
 */
const VRTBridge = () => {
  const {
    query
  } = useRouter();
  if (!('__vrt' in query)) {
    return null;
  }
  return <VRTBridgeInner data-sentry-element="VRTBridgeInner" data-sentry-component="VRTBridge" data-sentry-source-file="index.tsx" />;
};
export default VRTBridge;